import { Icon } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import { FC } from 'react';

import { useQuery } from '@tanstack/react-query';

import LockIconOpen from '@/assets/icons/ic-lock-open.svg';
import LockIcon from '@/assets/icons/ic-lock.svg';

import { queryLiblynxAuthorizationGrants } from '@/queries/liblynx-authorization-grants';
import { sessionQueryOptions } from '@/queries/upgrade/sessions';
import { PackageType } from '@/types/PackageType';

interface ILectureIcon {
  lecturePackage: PackageType;
}

export const LectureIcon: FC<ILectureIcon> = ({ lecturePackage }) => {
  const { data: session } = useQuery(sessionQueryOptions());
  const { user } = session || {};
  const { data } = useResource(queryLiblynxAuthorizationGrants('auth_grant'));

  const isPremium = session && user?.package === 'premium';
  const isLiblynxGrantActive = data?.status === 'active';
  const haveAccess = isPremium || isLiblynxGrantActive || lecturePackage === 'free';

  const svgIcon = haveAccess ? LockIconOpen : LockIcon;
  const iconColor = haveAccess ? 'teal.500' : 'gray.500';

  return <Icon as={svgIcon} h="1.5rem" w="1.5rem" color={iconColor} />;
};
